import { useEffect, useState } from 'react';
import { storeService } from '../services/storeService';
import { StoreFeaturedReview } from '../models';

export function useFeaturedReviews() {
  const [reviews, setReviews] = useState<StoreFeaturedReview[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    setError(null);

    storeService
      .getFeaturedReviews()
      .then((data) => {
        if (active) setReviews(data);
      })
      .catch((err) => {
        if (active) setError(err instanceof Error ? err : new Error('Erro ao carregar avaliações em destaque'));
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  return { reviews, isLoading, error, isEmpty: reviews.length === 0 };
}
